import { Injectable } from '@angular/core';
import { StartPoint } from '../models/start-point.model';
import { jsonHeaders } from './csrf';

export interface SessionTripState {
  stop_ids: number[];
  name: string | null;
  start: StartPoint | null;
}

@Injectable({ providedIn: 'root' })
export class SessionTripService {
  async fetch(): Promise<SessionTripState> {
    const res = await fetch('/api/v1/session_trip', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error(`session_trip GET failed: HTTP ${res.status}`);
    return (await res.json()) as SessionTripState;
  }

  async update(payload: {
    stop_ids?: number[];
    name?: string | null;
    start?: StartPoint | null;
  }): Promise<SessionTripState> {
    const res = await fetch('/api/v1/session_trip', {
      method: 'PATCH',
      headers: jsonHeaders(),
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`session_trip PATCH failed: HTTP ${res.status}`);
    return (await res.json()) as SessionTripState;
  }
}
